import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Privacy() {
  return (
    <div>
      {/* Header */}
      <Header showBack={true} />

      <div className="p-4">
        <div className="w-full max-w-md mx-auto flex flex-col gap-10">
          <Card>
            <CardHeader>
              <CardTitle className="text-2xl font-bold">
                Privacy Policy
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 text-sm text-muted-foreground">
              <section className="space-y-2">
                <h3 className="font-semibold text-base">
                  1. Information We Collect
                </h3>
                <p>
                  We collect information you provide directly to us, such as
                  when you create an account, use our services, or contact us
                  for support. This may include:
                </p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Name and contact information</li>
                  <li>Email address</li>
                  <li>Account credentials</li>
                  <li>Payment information</li>
                  <li>Communications with us</li>
                </ul>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">
                  2. How We Use Your Information
                </h3>
                <p>We use the information we collect to:</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Provide, maintain, and improve our services</li>
                  <li>Process transactions and send related information</li>
                  <li>Send technical notices and support messages</li>
                  <li>Respond to your comments and questions</li>
                  <li>Protect against fraudulent or illegal activity</li>
                </ul>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">
                  3. Information Sharing
                </h3>
                <p>
                  We do not sell, trade, or otherwise transfer your personal
                  information to third parties without your consent, except as
                  described in this policy:
                </p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>With service providers who assist in our operations</li>
                  <li>To comply with legal obligations</li>
                  <li>To protect rights and safety</li>
                  <li>With your consent or at your direction</li>
                </ul>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">4. Data Security</h3>
                <p>
                  We implement appropriate technical and organizational measures
                  to protect your personal information against unauthorized
                  access, alteration, disclosure, or destruction. However, no
                  security system is impenetrable.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">5. Data Retention</h3>
                <p>
                  We retain your personal information for as long as necessary
                  to provide you with our services and as described in this
                  Privacy Policy. We may also retain and use your information to
                  comply with legal obligations.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">6. Your Rights</h3>
                <p>You have the right to:</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Access your personal information</li>
                  <li>Correct inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Object to processing of your data</li>
                  <li>Request data portability</li>
                </ul>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">7. Cookies</h3>
                <p>
                  We use cookies and similar tracking technologies to track
                  activity on our service and hold certain information. You can
                  instruct your browser to refuse all cookies or to indicate
                  when a cookie is being sent.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">
                  8. Children's Privacy
                </h3>
                <p>
                  Our service is not directed to individuals under the age of
                  13. We do not knowingly collect personal information from
                  children under 13. If you become aware that a child has
                  provided us with personal data, please contact us.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">
                  9. International Data Transfers
                </h3>
                <p>
                  Your information may be transferred to and maintained on
                  computers located outside of your state, province, country, or
                  other governmental jurisdiction where data protection laws may
                  differ.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">
                  10. Changes to This Policy
                </h3>
                <p>
                  We may update our Privacy Policy from time to time. We will
                  notify you of any changes by posting the new Privacy Policy on
                  this page and updating the "Last updated" date.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">11. Contact Us</h3>
                <p>
                  If you have questions about this Privacy Policy, please
                  contact us at:
                </p>
                <p className="pl-5">
                  Email: privacy@fellascard.com
                  <br />
                  Address: FellasCard Inc.
                  <br />
                  123 Privacy Street
                  <br />
                  San Francisco, CA 94105
                </p>
              </section>

              <div className="pt-4 text-xs text-muted-foreground">
                Last updated: January 2025
              </div>
            </CardContent>
          </Card>

          {/* Footer */}
          <Footer />
        </div>
      </div>
    </div>
  );
}
